module.exports = __webpack_public_path__ + "img/Logo_white.046c74c4.png";